import { Commodity } from '@enmon/commons/lib/shared';
import {
  ELECTRICITY_REGISTERS_ALLOWED_UNITS,
  ElectricityRegister,
  GAS_REGISTERS_ALLOWED_UNITS,
  GasRegister,
  OTHER_REGISTERS_ALLOWED_UNITS,
  OtherRegister,
  THERMAL_REGISTERS_ALLOWED_UNITS,
  ThermalRegister,
  WATER_REGISTERS_ALLOWED_UNITS,
  WaterRegister,
} from '@enmon/commons/lib/shared/meter/registers/obises';
import { Unit } from '@enmon/commons/lib/shared/unit';

const obisByCommodity: Record<Commodity, Record<string, string>> = {
  [Commodity.Electricity]: ElectricityRegister,
  [Commodity.NaturalGas]: GasRegister,
  [Commodity.Other]: OtherRegister,
  [Commodity.Thermal]: ThermalRegister,
  [Commodity.Water]: WaterRegister,
};

const allowedUnitsByCommodity: Record<Commodity, Record<string, readonly Unit[]>> = {
  [Commodity.Electricity]: ELECTRICITY_REGISTERS_ALLOWED_UNITS,
  [Commodity.NaturalGas]: GAS_REGISTERS_ALLOWED_UNITS,
  [Commodity.Other]: OTHER_REGISTERS_ALLOWED_UNITS,
  [Commodity.Thermal]: THERMAL_REGISTERS_ALLOWED_UNITS,
  [Commodity.Water]: WATER_REGISTERS_ALLOWED_UNITS,
};

export function getObisMapForCommodity(commodity: Commodity | '') {
  return commodity ? (obisByCommodity[commodity] ?? {}) : {};
}

export function getAllowedUnitsForCommodity(commodity: Commodity | '') {
  return commodity ? (allowedUnitsByCommodity[commodity] ?? {}) : {};
}

export function formatEnumKey(value: string) {
  return value
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/([a-z\d])([A-Z])/g, '$1 $2')
    .trim();
}

export function formatUnitLabel(unit: Unit) {
  switch (unit) {
    case Unit.kWh:
      return 'kWh';
    case Unit.MWh:
      return 'MWh';
    case Unit.m3:
      return 'm3';
    case Unit.GJ:
      return 'GJ';
    case Unit.MJ:
      return 'MJ';
    default:
      return unit;
  }
}
